import { useEffect } from 'react';
import { useCommonSelector } from '@wajeez-web/stores/common';

const useDarkModeStyle = (
  querySelector: string,
  darkStyle: string,
  lightStyle: string
) => {
  const theme = useCommonSelector(({ common }) => common.settings.theme);

  useEffect(() => {
    let cssTemplateString = '';

    if (theme === 'dark') {
      cssTemplateString = `${querySelector} {
        ${darkStyle}
    }`;
    } else {
      cssTemplateString = `${querySelector} {
        ${lightStyle}
    }`;
    }

    const styleTag = document.createElement('style');
    styleTag.innerHTML = cssTemplateString;
    document.head.insertAdjacentElement('beforeend', styleTag);
  }, [theme, querySelector, darkStyle, lightStyle]);
};

export default useDarkModeStyle;
